import { Badge, Card, Grid, Icon, IconButton, InputLabel, Skeleton, Tooltip } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DataTable from "examples/Tables/DataTable";
import { Form, Formik } from "formik";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import { useCallback, useEffect, useRef, useState } from "react";
import { toDateTime } from "utils/DateUtils";
import { post } from "utils/WebService";
import Changes from "./Changes";

export default function HistoryConsult({ nomeEntidade, idEntidade, closeCreateEdit }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);
    const [viewDetails, setViewDetails] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [recordsTotal, setRecordsTotal] = useState(0);
    const [showTable, setShowTable] = useState(false);
    const [aplicar, setAplicar] = useState(false);

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
        data: null,
    });

    useEffect(() => {
        if (idEntidade != null) {
            setShowTable(true);
            setAplicar(true);
            fetchData({ ...tableState });
        }
    }, [idEntidade]);


    const fetchData = useCallback(({ pageSize, pageIndex, sorting, filter, data }) => {

        setLoadingTable(true);
        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: pageIndex ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: (filter && filter.length > 0) ? filter : tableState.current.filtered,
            data: data ? data : tableState.current.data,
        };

        tableState.current = updatedTableState;
        post("/history/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            filtered: updatedTableState.filtered,
            data: updatedTableState.data,
            codeEntity: nomeEntidade,
            idEntity: idEntidade,
        }).then(({ data, pages, recordsTotal }) => {
            const calculatedPages = Math.ceil(recordsTotal / updatedTableState.pageSize);
            setPages(calculatedPages > 0 ? calculatedPages : 1);
            setData(data);
            setRecordsTotal(recordsTotal);
            setLoadingTable(false);
            setAplicar(false);
        }).catch(() => {
            setLoadingTable(false)
            setAplicar(false);
        });

    }, []);

    const userColumns = [
        {
            header: "data",
            accessorKey: "data",
            cell: info => <DefaultCell>{toDateTime(info.getValue()) || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "usuario",
            accessorKey: "usuario.nome",
            cell: info => <DefaultCell>{info.getValue() || '-'}</DefaultCell>,
            isSorted: true,
        },
        {
            header: "ações",
            isSorted: false,
            cell: info => (
                <>
                    <Tooltip title="Alterações">
                        <IconButton
                            onClick={() => {
                                setSelectedId(info.row.original);
                                setViewDetails(true);
                            }}
                        >
                            <Badge
                                badgeContent={info.row.original.qtdeAlteracao}
                                color="error"
                                overlap="circular"
                                invisible={!info.row.original.qtdeAlteracao}
                            >
                                <MDTypography variant="h4">
                                    <Icon color="inherit" sx={{ marginRight: 1 }}>
                                        description
                                    </Icon>
                                </MDTypography>
                            </Badge>
                        </IconButton>
                    </Tooltip>
                </>
            ),
            width: "20%"
        },
    ];

    const handleApplyFilter = (values) => {
        setShowTable(true);
        setAplicar(true);
        fetchData({
            ...tableState, pageIndex: 0, data: values.data
        });
    };

    const handleCleanFilter = () => {
        let updatedTableState = {}

        updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: [],
            data: null
        };
        tableState.current = updatedTableState;

        fetchData({ ...updatedTableState })
    };

    function handleClose() {
        setViewDetails(false)
        setSelectedId(null)
    }

    return (
        <Grid container display="flex" justifyContent="center">

            {viewDetails &&
                <Changes
                    show={viewDetails}
                    close={handleClose}
                    header={`Detalhes da Alteração - ${toDateTime(selectedId?.data)}`}
                    dados={selectedId?.alteracao}
                />
            }

            <Grid item xs={12} md={12}>
                    <MDBox p={2}>
                        {closeCreateEdit && (
                            <MDBox display="flex" alignItems="center" pb={2}>
                                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                                    <MDTypography variant="h4">
                                        <Icon>arrow_back</Icon>
                                    </MDTypography>
                                </IconButton>
                                <MDTypography variant="h5">Histórico</MDTypography>
                            </MDBox>
                        )}


                    </MDBox>
                {(!showTable ?
                    <Skeleton variant="rectangular" height={pxToRem(300)} sx={{ borderRadius: 1 }} />
                    :
                    <DataTable
                        loading={loadingTable}
                        columnData={userColumns}
                        data={data}
                        fetchData={fetchData}
                        totalPages={pages}
                        totalRecords={recordsTotal}
                        tableState={tableState}
                        changeFilter={aplicar} />
                )}
            </Grid>
        </Grid >
    );
}

